import { render, staticRenderFns } from "./tinkListItem.vue?vue&type=template&id=6013e6fb"
import script from "./tinkListItem.vue?vue&type=script&lang=js"
export * from "./tinkListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports